import React from 'react'
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path className="cls-1" d="M15,8a1,1,0,0,1,1,1,1,1,0,0,1-1,1H9A1,1,0,0,1,9,8h5.94M15,7H9a2,2,0,0,0,0,4h6a2,2,0,0,0,0-4Z"/>
	  <path className="cls-1" d="M24,0H0V5H1V22H23V5h1ZM22,21H2V5H22ZM23,4H1V1H23Z"/>
  </React.Fragment>,
  'ShowAllIcon'
)